import React from 'react'
import { IntlProvider } from 'react-intl'
import useLocale from '../hooks/useLocale'
import { resources } from '../i18nResources'

const IntlProviderWrapper = (props: React.PropsWithChildren) => {
  const { locale } = useLocale()
  return (
    <IntlProvider
      locale={locale}
      messages={resources[locale as keyof typeof resources].translation}
    >
      {props.children}
    </IntlProvider>
  )
}

export default IntlProviderWrapper
